import { Pipe, PipeTransform } from '@angular/core';
import { TableColumn } from './ui-table-config.interface';

@Pipe({
    name: 'searchedColumns',
    pure: false,
    standalone: true,
})
export class SearchedColumnsPipe implements PipeTransform {
    transform(items: TableColumn<any>[]): any {
        if (!items) {
            return items;
        }
        return items.filter(item => item.inSearchResults);
    }
}
